module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_round_chestnut.621a428a.png";